export default __webpack_public_path__ + "static/media/cif-si.879739df.svg";